module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring_2.b80832a.jpg";